import { mapValues } from 'lodash'
import { getCookie } from '../../../../library'
import { getTemporaryPayNum } from '../../../api/vipPay'
import { pkg_tag } from '../data'
const getObj = () =>
  Object.keys(pkg_tag).reduce((i, k) => {
    i[k] = {}
    return i
  }, {})
export default {
  namespaced: true,
  state: {
    // 5元7天支付次数
    temporaryPayNum: null,
    couponData: getObj(),
    priceCalculate: {
      needCalculate: 0,
      calculating: false
    }
  },
  mutations: {
    commit_setTemporaryPayNum(state, payload) {
      state.temporaryPayNum = payload
    },
    commit_couponData(state, { tag, key, data, instead = false }) {
      const noopObj = { ...state.couponData }
      if (instead) {
        noopObj[tag][key] = data
      } else {
        noopObj[tag][key] = { ...noopObj[tag][key], ...data }
      }
      state.couponData = noopObj
    },
    commit_needCalculate(state, payload) {
      state.priceCalculate.needCalculate = payload
    },
    commit_calculating(state, payload) {
      state.priceCalculate.calculating = payload
    }
  },
  actions: {
    //  获取5元7天支付次数
    async dispatch_getTemporaryPayNum({ commit, state }) {
      if (state.temporaryPayNum !== null) {
        return state.temporaryPayNum
      }
      const res = await getTemporaryPayNum(getCookie('openid'))
      commit('commit_setTemporaryPayNum', res.temporaryPayNum)
      return res.temporaryPayNum
    }
  },
  getters: {
    gifts(state) {
      return mapValues(state.couponData, (i) => i.gifts || {})
    },
    cardIds(state) {
      return mapValues(state.couponData, (i) => i.cardIds)
    },
    selectCard(state) {
      return mapValues(state.couponData, (i) => i.selectCard || {})
    },
    cardsubprice(state) {
      return mapValues(state.couponData, (i) => i.cardsubprice || 0)
    },
    basicPrice(state) {
      return mapValues(state.couponData, (i) => i.basicPrice || 0)
    },
    busifavor(state) {
      return mapValues(state.couponData, (i) => i.busifavor || {})
    }
  }
}
